import { TransportDetailsModule } from './../../../common/components/transport-details/transport-details.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionTabletTransportItemComponent } from './action-tablet-transport-item/action-tablet-transport-item.component';
import { CommonLayoutModule, CommonUIElementsModule } from '@sdbn/common';
import { MatRippleModule } from '@angular/material/core';
import { ActionTabletModule } from '@sdbn/appclient';



@NgModule({
  declarations: [
    ActionTabletTransportItemComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    CommonUIElementsModule,
    ActionTabletModule,
    TransportDetailsModule,
    MatRippleModule
  ]
})
export class ActionTabletTransportModule { }
